/** Public site URL for canonicals, OG URLs, and JSON-LD (set in production builds). */
export function getSiteUrl() {
  const env = (process.env.REACT_APP_SITE_URL || "").trim().replace(/\/+$/, "");
  if (env) return env;
  if (typeof window !== "undefined" && window.location?.origin) return window.location.origin;
  return "";
}

export const SITE_NAME = "MossMatrix";

/** Fallback when REACT_APP_SITE_URL is unset at build time (sitemap / robots). */
export const SITEMAP_BASE_URL = (process.env.REACT_APP_SITE_URL || "https://mossmatrix.com").replace(/\/+$/, "");
